<h2 class="step-title" >What is your name?</h2>
@if (experiment) {
  <h3 style="margin: -1.375rem 0 1.375rem 0;">Personal Information is Safe & Secure.</h3>
}
@if (notDebtSettlement) {
  <p class="step-subtitle">{{ isReverseFlow ? 'No credit check to connect with lenders.' : 'Get rates with no credit check required!' }}</p>
}
@if (useUpdatedInputs) {
  <div class="field name-field">
    <div class="name-input-group"
      [ngClass]="{
        'has-error': highlightingBoxForRequiredInfo && ((controls[0].touched && controls[0].errors) || (controls[1].touched && controls[1].errors))
      }">
      <div class="control name-input-row">
        @if (!inputModeTest) {
          <input class="input is-large name-input" type="text" placeholder="First Name" formControlName="firstName"
          [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
          #firstName (change)="snap()" name="firstName" autocomplete="given-name" >
        }
        @if (inputModeTest) {
          <input inputmode="text" class="input is-large name-input" type="text" placeholder="First Name" formControlName="firstName"
          [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
          #firstName (change)="snap()" name="firstName" autocomplete="given-name" >
        }
      </div>

      <div class="name-divider" aria-hidden="true"></div>

      <div class="control name-input-row">
        @if (!inputModeTest) {
          <input class="input is-large name-input" type="text" placeholder="Last Name" formControlName="lastName"
          [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
          #lastName (change)="snap()" name="lastName" autocomplete="family-name">
        }
        @if (inputModeTest) {
          <input inputmode="text" class="input is-large name-input" type="text" placeholder="Last Name" formControlName="lastName"
          [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
          #lastName (change)="snap()" name="lastName" autocomplete="family-name">
        }
      </div>
    </div>

    @if (controls[0].touched && controls[0].errors) {
      <div class="help is-danger has-text-left">
        @if (controls[0].errors.required) {
          <p>First Name is required.</p>
        }
        @if (controls[0].errors.pattern) {
          <p>Invalid characters in First Name.</p>
        }
        @if (controls[0].errors.minlength) {
          <p>First Name must be at least {{controls[0].errors.minlength.requiredLength}} characters.</p>
        }
        @if (controls[0].errors.fakeName) {
          <p>Please enter your real first name so lenders can match your options accurately.</p>
        }
      </div>
    }

    @if (controls[1].touched && controls[1].errors) {
      <div class="help is-danger has-text-left">
        @if (controls[1].errors.required) {
          <p>Last Name is required.</p>
        }
        @if (controls[1].errors.pattern) {
          <p>Invalid characters in Last Name.</p>
        }
        @if (controls[1].errors.minlength) {
          <p>Last Name must be at least {{controls[1].errors.minlength.requiredLength}} characters.</p>
        }
        @if (controls[1].errors.fakeName) {
          <p>Please enter your real last name so lenders can match your options accurately.</p>
        }
      </div>
    }
  </div>
} @else {
  <div class="field">
    <div class="control">
      @if (!inputModeTest) {
        <input class="input is-large" type="text" placeholder="First Name" formControlName="firstName"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
        #firstName (change)="snap()" name="firstName" autocomplete="given-name" >
      }
      @if (inputModeTest) {
        <input inputmode="text" class="input is-large" type="text" placeholder="First Name" formControlName="firstName"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
        #firstName (change)="snap()" name="firstName" autocomplete="given-name" >
      }
    </div>

    @if (controls[0].touched && controls[0].errors) {
      <div class="help is-danger has-text-left">
        @if (controls[0].errors.required) {
          <p>First Name is required.</p>
        }
        @if (controls[0].errors.pattern) {
          <p>Invalid characters in First Name.</p>
        }
        @if (controls[0].errors.minlength) {
          <p>First Name must be at least {{controls[0].errors.minlength.requiredLength}} characters.</p>
        }
        @if (controls[0].errors.fakeName) {
          <p>Please enter your real first name so lenders can match your options accurately.</p>
        }
      </div>
    }
  </div>

  <div class="field">
    <div class="control">
      @if (!inputModeTest) {
        <input class="input is-large" type="text" placeholder="Last Name" formControlName="lastName"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
        #lastName (change)="snap()" name="lastName" autocomplete="family-name">
      }
      @if (inputModeTest) {
        <input inputmode="text" class="input is-large" type="text" placeholder="Last Name" formControlName="lastName"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
        #lastName (change)="snap()" name="lastName" autocomplete="family-name">
      }
    </div>

    @if (controls[1].touched && controls[1].errors) {
      <div class="help is-danger has-text-left">
        @if (controls[1].errors.required) {
          <p>Last Name is required.</p>
        }
        @if (controls[1].errors.pattern) {
          <p>Invalid characters in Last Name.</p>
        }
        @if (controls[1].errors.minlength) {
          <p>Last Name must be at least {{controls[1].errors.minlength.requiredLength}} characters.</p>
        }
        @if (controls[1].errors.fakeName) {
          <p>Please enter your real last name so lenders can match your options accurately.</p>
        }
      </div>
    }
  </div>
}


<button class="button continue is-large has-shadow-small" (click)="submit()">
  Continue
  <i class="fas fa-chevron-right"></i>
</button>
